// extracted by mini-css-extract-plugin
export var topBun = "index-module--topBun--1AFPi";
export var bottomBun = "index-module--bottomBun--D6wSB";
export var midBun = "index-module--midBun--1ooVd";